import React, { useEffect, useState } from 'react'
import Navbar from '../component/Navbar'
import Header from '../component/Header'
import { Box, Card, Container, ListItemIcon, MenuItem, MenuList, Pagination, Stack, Typography, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { jobLoadAction } from '../redux/actions/jobAction'
import { Link, useParams } from 'react-router-dom'
import CardElement from '../component/CardElement'
import Footer from '../component/Footer'
import LoadingBox from '../component/LoadingBox'
import SelectComponent from '../component/SelectComponent'
import { jobTypeLoadAction } from '../redux/actions/jobTypeAction'
import LocationOnIcon from '@mui/icons-material/LocationOn';



const Home = () => {
    const { jobs, setUniqueLocation, pages, loading } = useSelector(state => state.loadJobs);

    const { palette } = useTheme();
    const dispatch = useDispatch();
    const { keyword, location } = useParams();

    const [page, setPage] = useState(1);
    const [cat, setCat] = React.useState('');

    useEffect(() => {
        dispatch(jobLoadAction(page, keyword, cat, location));
    }, [page, keyword, cat, location]);

    useEffect(() => {
        dispatch(jobTypeLoadAction());
    }, []);

    const handleChangeCategory = (e) => {
        setCat(e.target.value);
    }

    return (
        <>
            <Box sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>

                <Navbar />
                <Header />
                <Container>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                    >
                        <Box sx={{ flex: 2, p: 2 }}>
                            <Card sx={{ minWidth: 150, mb: 3, mt: 3, p: 2, bgcolor: palette.primary.white }}>
                                <Box sx={{ pb: 2 }}>
                                    <Typography component="h4" sx={{ color: '#454545', fontWeight: 600 }}  style={{ fontFamily: 'Montserrat, sans-serif', fontSize:'16px' }}>
                                        Filter job by category
                                    </Typography>
                                </Box>
                                <SelectComponent handleChangeCategory={handleChangeCategory} cat={cat} />

                            </Card>

                            {/* jobs by location */}
                            <Card sx={{ minWidth: 150, mb: 3, mt: 3, p: 2, bgcolor: palette.primary.white }} >
                                <Box sx={{ pb: 2 }}>
                                    {/* <h4>Filter by category</h4> */}
                                    <Typography component="h4" sx={{ color: '#454545', fontWeight: 600 }}  style={{ fontFamily: 'Montserrat, sans-serif', fontSize:'16px' }}>
                                        Filter job by location
                                    </Typography>
                                    <MenuList>
                                        {
                                            setUniqueLocation && setUniqueLocation.map((location, i) => (
                                                <MenuItem key={i}  style={{ fontFamily: 'Montserrat, sans-serif', fontSize:'16px' }}>
                                                    <ListItemIcon>
                                                        <LocationOnIcon sx={{ color: palette.secondary.main, fontSize: 18 }} />
                                                    </ListItemIcon>
                                                    <Link style={{ color: palette.secondary.main }} to={`/search/location/${location}`}>{location}</Link>
                                                </MenuItem>

                                            ))
                                        }

                                    </MenuList>

                                </Box>
                            </Card>
                        </Box>
                        <Box sx={{ flex: 5, p: 2 }}>
  {
    loading ? (
      <div>
        <LoadingBox />
        <LoadingBox />
      </div>
    ) : (
      (jobs && jobs.length === 0) || !jobs ? (
        <>
          <Box
            sx={{
              minHeight: '350px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <h2 className='no-data' style={{ fontFamily: 'Montserrat, sans-serif', fontSize:'20px', color:'#454545' }}>
              Currently, there are no job openings available.
            </h2>
          </Box>
        </>
      ) : (
        <>
          {jobs && jobs.map((job, i) => (
            <CardElement
              key={i}
              id={job._id}
              jobTitle={job.title}
              description={job.description}
              category={job.jobType ? job.jobType.jobTypeName : "No category"}
              location={job.location}
            />
          ))}
          {jobs && jobs.length > 0 && ( // Only render Pagination if there are jobs
            <Stack spacing={2}>
              <Pagination
                style={{ fontFamily: 'Montserrat, sans-serif' }}
                color="primary"
                variant="outlined"
                page={page}
                count={pages === 0 ? 1 : pages}
                onChange={(event, value) => setPage(value)}
              />
            </Stack>
          )}
        </>
      )
    )
  }
</Box>
                    </Stack>
                </Container>
            </Box>
            <Footer />

        </>
    )
}

export default Home